import * as React from "react";
import { forwardRef } from "react";
const PlaySVG = (props, ref) => React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", ref: ref, ...props },
    React.createElement("path", { d: "M9 33.269V6.73a1 1 0 0 1 1.5-.866l22.999 13.269a1 1 0 0 1 0 1.732l-23 13.269A1 1 0 0 1 9 33.269" }));
const ForwardRef = forwardRef(PlaySVG);
export default ForwardRef;
//# sourceMappingURL=Play.js.map